"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CloseButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _index = require("../ButtonTertiary/index.js");
var _index2 = require("../Icon/icons/IconX/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var CloseButtonStyled = (0, _styledComponents["default"])(_index.ButtonTertiary).withConfig({
  displayName: "CloseButton__CloseButtonStyled",
  componentId: "sc-1n0japy-0"
})(["position:absolute;right:0;top:0;[dir='rtl'] &{right:unset;left:0;}"]);
var CloseButton = exports.CloseButton = function CloseButton(props) {
  return /*#__PURE__*/_react["default"].createElement(CloseButtonStyled, {
    iconOnly: _index2.IconX,
    "aria-label": props.closeButtonAriaLabel,
    onClick: props.onClose,
    type: "button"
  });
};